import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Evaluation/ValueAnalysis/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class ValueAnalysisQueries extends VueCqrs 
{
	runResultsPageQueryV1(workspaceId: number, projectId: number, evalModelId: number, viewDefId: string | null, weightsSetId: number | null, scoringSurveyId: number | null, scoringProjectUserId: number | null)
	{
		const query = q.buildResultsPageQueryV1(workspaceId, projectId, evalModelId, viewDefId, weightsSetId, scoringSurveyId, scoringProjectUserId);
		this.$query(query);
	}

	runScoringPanelistsBySurveyIdQueryV1(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		const query = q.buildScoringPanelistsBySurveyIdQueryV1(workspaceId, projectId, evalModelId, surveyId);
		this.$query(query);
	}
}
